var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    transform: "rotate(180)",
    fill: "#c4c4c4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Penis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.14 17c-.62-13-15.49-20.62-26.39-12.95a6.46 6.46 0 0 1 -7.5 0 16.78 16.78 0 1 0 -11.49 30.41 55.14 55.14 0 0 1 .66-6 1 1 0 0 1 2 .19c-.31 1.85-.64 5.26-.64 6a16.74 16.74 0 0 0 13.22-6.76 16.74 16.74 0 0 0 13.24 6.68 59.44 59.44 0 0 0 -1.54-10.42c-1.3-5.2-1.21-4.79-1.21-4.89a1 1 0 0 1 2-.19 92.49 92.49 0 0 1 2.36 11c.25 1.81.41 4 .41 4.39a16.77 16.77 0 0 0 14.88-17.46zm-42.77 7a1 1 0 0 1 -.73-1.21l.89-3.6a1 1 0 0 1 1.94.48l-.89 3.6a1 1 0 0 1 -1.21.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.23 34.39c-.36-7.82-2.74-14.18-2.74-15.13-24.89 9.93-23 9.13-23.09 9.32s-.07 0-.4 3.06c-.19 1.53-.07-.16-2.27 39.53a4.36 4.36 0 0 0 1.82 3.83 5.85 5.85 0 0 1 3.52-1.18h19.86a5.85 5.85 0 0 1 3.52 1.18 4.36 4.36 0 0 0 1.82-3.8c-.01-.15-2.01-36.68-2.04-36.81zm-4.23 36.12a1 1 0 0 1 -1.35.41 7.19 7.19 0 0 0 -6.1-.13 4.36 4.36 0 0 1 -3.64 0 7.21 7.21 0 0 0 -5.55-.12 1 1 0 0 1 -1.36-.55 1 1 0 0 1 .55-1.3 9.26 9.26 0 0 1 7.16.16 2.27 2.27 0 0 0 1.94 0 9.2 9.2 0 0 1 7.89.18 1 1 0 0 1 .46 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.83 30.25c-.72-5.38-2.34-10.28-2.34-10.93a83 83 0 0 1 2.34 10.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.4 28.61c0 .15 0 0-.23 1.58.06-.53.14-1.05.23-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.73 80.24c-.63 3.94-.78 6.68-3.47 9.94a13.27 13.27 0 0 1 -9.26 4.82v-5.59a1 1 0 0 0 -2 0v5.59a13.27 13.27 0 0 1 -9.26-4.78c-2.74-3.32-2.87-6.22-3.47-9.98a3.85 3.85 0 0 1 3.8-4.45h19.86a3.85 3.85 0 0 1 3.8 4.45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDick);
export default __webpack_public_path__ + "static/media/dick.a88413aecede975041b5b0b034790c45.svg";
export { ForwardRef as ReactComponent };